import { render } from "./detailContent.vue?vue&type=template&id=504deb80&scoped=true"
import script from "./detailContent.vue?vue&type=script&lang=js"
export * from "./detailContent.vue?vue&type=script&lang=js"

import "./detailContent.vue?vue&type=style&index=0&id=504deb80&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-new-front.rule.vip.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504deb80"]])

export default __exports__